import { useEffect, useState } from 'react';

// Shared narrow-viewport breakpoint. Matches the IslandMap mobile cutoff so
// the IDE and map stay in sync about what counts as "mobile" layout.
export const MOBILE_BREAKPOINT = 760;

export function useIsMobile(breakpoint: number = MOBILE_BREAKPOINT): boolean {
  const [isMobile, setIsMobile] = useState(() =>
    typeof window !== 'undefined' &&
    window.matchMedia(`(max-width: ${breakpoint}px)`).matches,
  );
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const mql = window.matchMedia(`(max-width: ${breakpoint}px)`);
    const onChange = (e: MediaQueryListEvent) => setIsMobile(e.matches);
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, [breakpoint]);
  return isMobile;
}
